module.exports = __webpack_public_path__ + "LGFabout-3.641f2eba.png";